import styled from "@emotion/styled";
import { Typography } from "@mui/material";;

const PageTitle = styled(Typography)({
  fontSize: "1.5rem",
  fontFamily: "NanumSquareExtraBold",
  borderBottom: "2px solid #dbdbdb",
  marginBottom: "1rem"
});

export default PageTitle;